<template>
  <div class="pa-park-area-banner" :class="additionalParkAreaSetClass" @click.prevent="handleClick">
    <div class="pa-title">{{areaName}}</div>
    <div class="area-level-view">
      <template v-for="(iconName,key) in parkPositionLevelIcon">
        <span :key="key">
          <component :is="iconName" />
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import ParkAreaIconCloverImage from '@/components/Parts/PAParkBanner/Images/clover-icon.svg?inlineN'
import ParkAreaIconEmptyImage from '@/components/Parts/PAParkBanner/Images/empty-icon.svg?inlineN'

export default {
  props : {
    couldDisplayAreaInfomationModal : {
      default:false,
    },

    areaName : {
      default: 'アオの地区'
    },

    areaLevel : {
      default: 'clover'
    },

    areaLevelNum : {
      default: 1
    }
  },

  components : {
    ParkAreaIconEmptyImage,
    ParkAreaIconCloverImage
  },

  data(){
    return {
      additionalParkAreaSetClass  : {
        'pa-park-area-banner-blue'    : false,
        'pa-park-area-banner-yellow'  : false,
        'pa-park-area-banner-red'     : false
      },
      parkPositionSlotMax         : 3,
      parkPositionLevelIcon       : []
    };
  },

  watch : {
    areaName : {
      handler(value){
        switch(value){
          case 'アオの地区':
            this.additionalParkAreaSetClass['pa-park-area-banner-blue']   = true;
            this.additionalParkAreaSetClass['pa-park-area-banner-yellow'] = false;
            this.additionalParkAreaSetClass['pa-park-area-banner-red']    = false;
          break;

          case 'キイの地区':
            this.additionalParkAreaSetClass['pa-park-area-banner-blue']   = false;
            this.additionalParkAreaSetClass['pa-park-area-banner-yellow'] = true;
            this.additionalParkAreaSetClass['pa-park-area-banner-red']    = false;
          break;

          case 'ベニの地区':
            this.additionalParkAreaSetClass['pa-park-area-banner-blue']   = false;
            this.additionalParkAreaSetClass['pa-park-area-banner-yellow'] = false;
            this.additionalParkAreaSetClass['pa-park-area-banner-red']    = true;
          break;
        }
      },
      immediate: true
    },

    areaLevelNum : {
      handler(value){
        this.parkPositionLevelIcon = [];

        for(let counter = 0; counter < value; counter++){
          switch(this.areaLevel){
            case 'clover':
              this.parkPositionLevelIcon.push('ParkAreaIconCloverImage');
            break;
          }
        }

        const remainSlot = this.parkPositionSlotMax - value;
        
        for(let remainCounter = 0; remainCounter < remainSlot; remainCounter++){
          this.parkPositionLevelIcon.push('ParkAreaIconEmptyImage');
        }
      },
      immediate: true
    },

    couldDisplayAreaInfomationModal : {
      handler(value){
        if(value){
          this.additionalParkAreaSetClass['pa-park-area-banner-clickable']   = true;
        }else{
          this.additionalParkAreaSetClass['pa-park-area-banner-clickable']   = false;
        }
      },
      immediate: true
    }
  },

  methods : {
    handleClick(){
      if(this.couldDisplayAreaInfomationModal === false) return;
      
      this.$emit('click');
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-park-area-banner{
  border-radius: 4px;
  margin:.2rem .4rem .3rem;

  @include from($desktop) {
    margin:6px 8px 8px;
  }

  .pa-title{
    // color:#D2BA9E;
    // color:#2a5686;
    text-align: center;
    font-size:.85rem;
    font-weight: normal;
    margin:0;
    padding:.08rem 0 .1rem;

    @include from($desktop) {
      font-size:1.1rem;
      padding:4px 0 2px;
    }

    @include until(375px) {
      font-size:.7rem;
    }
  }

  .area-level-view{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-bottom:.2rem;

    svg{
      width:1.3rem;
      margin-right: .3rem;
      circle{
        fill:#c8c8c8;
      }
    }

    @include from($desktop) {
      padding:0 8px;

      svg{
        width:2rem;
        margin-right: .5rem;
      }
    }
  }

  &-clickable{
    cursor:pointer;
  }

  &-blue{
    background-color: #7192B5;

    .pa-title{
      color:#2a5686;
    }

    .area-level-view{
      svg{
        .a{fill:#c8c8c8;}
        .b{fill:#446991;}
      }
    }
  }

  &-yellow{
    background-color: #B0A31F;
    
    .pa-title{
      color:#796e0e;
    }

    .area-level-view{
      svg{
        .a{fill:#c8c8c8;}
        .b{fill:#796e0e;}
      }
    }
  }

  &-red{
    background-color: #A61E32;
    
    .pa-title{
      color:#5f0b0d;
    }

    .area-level-view{
      svg{
        .a{fill:#c8c8c8;}
        .b{fill:#5f0b0d;}
      }
    }
  }

  &-white{
    background-color: #f7f7f7;
    background-color: #e9e7e7;
    
    .pa-title{
      color:#929292;
    }

    .area-level-view{
      svg{
        .a{fill:#dbdbdb;}
        .b{fill:#929292;}
      }
    }
  }
}
</style>